import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getInventoriesQueryOptions } from '@/_pages/inventories/api-service';

export const Route = createFileRoute('/_private/inventory/')({
  staticData: { isFullWidth: true },
  validateSearch: filterState.parse,
  loader: (opts) => opts.context.queryClient.ensureQueryData(getInventoriesQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={4} numberOfButtons={3} />,
});
